import { Button } from '@/components/ui/common/Button'
import { useFilesHandler } from '@/hooks/use-files-handler'
import { cn } from '@/utils'
import { ArrowDownFromLine, Check, Upload } from 'lucide-react'
import { useEffect } from 'react'
import { useFormField } from '../../form/Form'

interface IProps {
  title: string
  name: string
  value?: string
  onChange: (event: { target: { name: string; value: string | string[] } }) => void
}

const UploadArea = ({ title, value, onChange, name }: IProps) => {
  const { getRootProps, getInputProps, tmpLocation, isDragActive, open } =
    useFilesHandler()
  const { error } = useFormField()
  useEffect(() => {
    if (tmpLocation) {
      onChange({
        target: {
          name,
          value: tmpLocation
        }
      })
    }
  }, [tmpLocation, onChange])

  return (
    <div className="flex w-full flex-col">
      <div
        {...getRootProps()}
        className={cn(
          'relative flex w-full flex-col items-center justify-center gap-3 rounded-xl border border-dashed py-5 transition-colors',
          isDragActive
            ? 'border-primary'
            : 'border-gray dark:border-gray-foreground transition-colors',
          error ? 'border-destructive' : ''
        )}
        data-cy="drag-and-drop"
      >
        <IconComponent isDragActive={isDragActive} isUploaded={!!value} />
        <div>
          <h3 className="max-w-full overflow-hidden px-2 text-center text-base tracking-tighter text-ellipsis text-black">
            {title}
          </h3>
          <h3 className="max-w-full overflow-hidden px-2 text-center text-base tracking-tighter text-ellipsis text-black">
            {value ? value.split('/').at(-1) : 'Nie wybrano pliku'}
          </h3>
        </div>
        <Button onClick={open} type="button" variant="outline">
          Wybierz plik
        </Button>
      </div>
      <input {...getInputProps()} />
    </div>
  )
}

const IconComponent = ({
  isDragActive,
  isUploaded
}: {
  isDragActive: boolean
  isUploaded: boolean
}) => {
  return (
    <div className="relative size-10">
      {/* <FileIcon width={80} height={80} /> */}
      <div className="absolute right-0 bottom-0 flex size-10 items-center justify-center rounded-full bg-primary">
        <Upload
          className={cn(
            'absolute text-white transition-all',
            !isDragActive && !isUploaded ? 'scale-100' : 'scale-0'
          )}
        />
        <ArrowDownFromLine
          className={cn(
            'absolute text-white transition-all',
            isDragActive ? 'scale-100' : 'scale-0'
          )}
        />
        <Check
          className={cn(
            'absolute text-white transition-all',
            isUploaded && !isDragActive ? 'scale-100' : 'scale-0'
          )}
        />
      </div>
    </div>
  )
}
export default UploadArea
